import { Typography, Box, CircularProgress } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Employee } from '../types/Employee/Employee'
import { getQCs } from '../services/requestService'
import { SelectQCList } from '../components/InspectionBacklog/SelectQCList'

const QcSelectionPage = () => {
	const [qcWorkers, setQcWorkers] = useState<Employee[]>()
	const [loading, setLoading] = useState<boolean>(false)
	useEffect(() => {
		;(async () => {
			setLoading(true)
			const found = await getQCs(true)
			setQcWorkers(found ? found : undefined)
			setLoading(false)
		})()
	}, [])

	return (
		<>
			<Box sx={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 64px)' }}>
				<Typography
					sx={{
						fontSize: '1.5rem',
						paddingLeft: '1rem',
						paddingTop: '.5rem',
						outline: '1px solid #DDDDDD',
						zIndex: '3',
					}}
				>
					Quality Control Agents
				</Typography>
				<Box sx={{ display: 'flex', flex: 1, overflowY: 'auto' }}>
					{loading ? <CircularProgress color='success' /> : <SelectQCList agents={qcWorkers} />}
				</Box>
			</Box>
		</>
	)
}

export default QcSelectionPage
